module.exports = __webpack_public_path__ + "static/media/CorpsNetworkMembersData.e97310ad.csv";